/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React, { useState, useEffect } from "react";
import { SimpliCitySDK } from "cms/sdk";
import { objectHasPropertyString, isObject } from "cms/utils/empty-exists";
import { useAuth } from "cms/auth/hooks/useAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Logger } from "cms/utils/logger";

const LinkButtonItem = (props) => {

    const { token } = useAuth();
    const item = props?.item ?? {};
    const colour = item?.colour ?? "brand";
    const icon = item?.icon ?? "none";
    const style = item?.style ?? "primary";

    const [link, setLink] = useState();
    const [target, setTarget] = useState(undefined);
    const [classes, setClasses] = useState("btn icon");

    useEffect(() => {
        const load = async () => {
            if (objectHasPropertyString(item, "link")) {
                Logger.debug(`loading link from DB: `, item?.link);
                const _link = await SimpliCitySDK.link.findOne(token, item?.link);
                setLink(_link);
                if (_link?.is_external || _link?.new_tab) {
                    setTarget("_blank");
                }
                let class_list = ["btn icon"];
                class_list.push(colour);
                class_list.push(style);
                setClasses(class_list.join(" "));
                return _link;
            }
        };
        // load once
        if (!isObject(link) || !objectHasPropertyString(link, "guid")) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item?.link]);

    return (
        <div className='simplicity-linkbutton'>
            {link && link?.url && link?.text && (
                <a className={classes} href={link?.url} target={target}>
                    <div>{link?.text}</div>
                    {icon === "external" &&
                        <FontAwesomeIcon icon={`fa-regular fa-arrow-up-right-from-square`} />
                    }
                    {icon === "arrow" &&
                        <FontAwesomeIcon icon={`fa-regular fa-arrow-right`} />
                    }
                </a>
            )}
        </div>
    );
};

LinkButtonItem.displayName = "LinkButtonItem";
export { LinkButtonItem };
